const CHECK_INTERVAL_MS = 60 * 1000;

/**
 * Reload the page when the deployed build is in maintenance mode,
 * so users with the app already open end up on the maintenance page.
 */
export function watchMaintenanceMode() {
    setInterval(checkMaintenanceMode, CHECK_INTERVAL_MS);

    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            checkMaintenanceMode();
        }
    });
}

async function checkMaintenanceMode() {
    try {
        const response = await fetch(`/maintenance.json?t=${Date.now()}`, { cache: 'no-store' });

        if (!response.ok) {
            return;
        }

        const status = await response.json();

        if (status?.maintenance === true) {
            window.location.reload();
        }
    } catch (_error) {
        // Missing or invalid status file (e.g. in development): ignore.
    }
}
